import { render } from "./WidgetAssign.vue?vue&type=template&id=b9bd62c4&ts=true"
import script from "./WidgetAssign.vue?vue&type=script&lang=ts"
export * from "./WidgetAssign.vue?vue&type=script&lang=ts"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__